// Lightweight reCAPTCHA v3 loader & token getter
const SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY;
let scriptLoading = null;

function ensureScript() {
    if (!SITE_KEY) return Promise.resolve(null);
    if (typeof window === "undefined") return Promise.resolve(null);
    if (window.grecaptcha && window.grecaptcha.execute) return Promise.resolve(window.grecaptcha);
    if (scriptLoading) return scriptLoading;

    scriptLoading = new Promise((resolve, reject) => {
        const existing = document.querySelector(`script[src*="recaptcha/api.js"]`);
        if (existing) {
            existing.addEventListener("load", () => resolve(window.grecaptcha));
            return;
        }
        const s = document.createElement("script");
        s.src = `https://www.google.com/recaptcha/api.js?render=${SITE_KEY}`;
        s.async = true;
        s.defer = true;
        s.onload = () => {
            if (window.grecaptcha) {
                window.grecaptcha.ready(() => resolve(window.grecaptcha));
            } else {
                reject(new Error("grecaptcha not available after load"));
            }
        };
        s.onerror = () => reject(new Error("Failed to load reCAPTCHA script"));
        document.head.appendChild(s);
    });
    return scriptLoading;
}

export async function getRecaptchaToken(action = "subscribe") {
    if (!SITE_KEY) return null;
    try {
        const g = await ensureScript();
        if (!g) return null;
        return await g.execute(SITE_KEY, { action });
    } catch (e) {
        console.warn("reCAPTCHA token fetch failed:", e);
        return null;
    }
}

export const recaptchaEnabled = !!SITE_KEY;
